/**
 * Configurations for Adding Liquidity Presets
 */
import {parseEther} from "viem";


// 1) Spot (Uniform)
export const spotUniform = {
  deltaIds: [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
  distributionX: [
    0, 0, 0, 0, 0, 0.090909, 0.181818, 0.181818, 0.181818, 0.181818, 0.181818
  ].map((el) => parseEther(el.toString())),
  distributionY: [
    0.181818, 0.181818, 0.181818, 0.181818, 0.181818, 0.090909, 0, 0, 0, 0, 0
  ].map((el) => parseEther(el.toString()))
}

// 2) Max (Uniform)
export const maxUniform = {
  deltaIds: [
    -25, -24, -23, -22, -21, -20, -19, -18, -17, -16, -15, -14, -13, -12, -11,
    -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
    11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25
  ],
  distributionX: [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0.0196, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392,
    0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392,
    0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392
  ].map((el) => parseEther(el.toString())),
  distributionY: [
    0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392,
    0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392,
    0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0392, 0.0196, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
  ].map((el) => parseEther(el.toString()))
}

// 3) Bid-Ask
export const bidAsk = {
  deltaIds: [-10, -9, -8, -7, -6, 6, 7, 8, 9, 10],
  distributionX: [0, 0, 0, 0, 0, 0.04, 0.12, 0.2, 0.28, 0.36].map((el) =>
    parseEther(el.toString())
  ),
  distributionY: [0.36, 0.28, 0.2, 0.12, 0.04, 0, 0, 0, 0, 0].map((el) =>
    parseEther(el.toString())
  )
}

// 4) Normal
export const normal = {
  deltaIds: [
    -15, -14, -13, -12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2,
    3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15
  ],
  distributionX: [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.0925, 0.185, 0.1475, 0.12,
    0.0975, 0.0775, 0.06, 0.05, 0.04, 0.03, 0.025, 0.02, 0.0175, 0.015, 0.0125,
    0.01
  ].map((el) => parseEther(el.toString())),
  distributionY: [
    0.01, 0.0125, 0.015, 0.0175, 0.02, 0.025, 0.03, 0.04, 0.05, 0.06, 0.0775,
    0.0975, 0.12, 0.1475, 0.185, 0.0925, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0
  ].map((el) => parseEther(el.toString()))
}
